import { INDIVIDUAL } from './_http';

const policeSorgula = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Cgm/PoliceSorgula`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const policeListesiSorgula = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Cgm/PoliceListesiSorgula`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const provizyonOlustur = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Cgm/ProvizyonOlustur`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const provizyonSorgula = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Cgm/ProvizyonSorgula`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
export { provizyonSorgula, policeListesiSorgula, provizyonOlustur,policeSorgula }